import { PackageItemFormData } from "@src/common/components/PackageDimensionsForm/PackageDimensionsForm";
import { PackageTypeOrSizeMode } from "@src/common/components/PackageDimensionsForm/packageTypeOrSizeMode";
import {
  derivedNumPackages,
  derivedShipmentPackageTypeId,
  packageItemsForCreateSubmit,
  shipmentPackageSizeId,
  totalPackageItemWeight,
} from "@src/common/utils/packageItems";

interface BuildEditOrderPackageUpdateArgs {
  packageItems: PackageItemFormData[] | undefined;
  packageSize: unknown;
  packageTypeOrSizeMode: PackageTypeOrSizeMode;
}

export function buildEditOrderPackageUpdate({
  packageItems,
  packageSize,
  packageTypeOrSizeMode,
}: BuildEditOrderPackageUpdateArgs) {
  return {
    numPackages: derivedNumPackages(packageItems, true),
    packageWeightInPounds: totalPackageItemWeight(packageItems),
    packageTypeId: derivedShipmentPackageTypeId(
      packageItems,
      packageTypeOrSizeMode,
    ),
    packageSize: shipmentPackageSizeId(packageSize),
    packageItems: packageItemsForCreateSubmit(packageItems) ?? [],
  };
}
